import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import './Contact.css';
import ContactUs from './ContactUs/ContactUs';
// eslint-disable-next-line
import i18n from "../../i18n";
import { useTranslation } from 'react-i18next';



const Contact = () => {
    const { t, i18n } = useTranslation();
    
    return (
        <section id="contact" className="contact">
            <div className="container" data-aos="fade-up" data-aos-duration="800">

                <div className="section-title">
                    <h2>{t('Contact')}</h2>
                    <p>{t('For_any_inquiries')}</p>
                </div>

                <div>
                    <iframe className='iframe' src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d831.6199007311674!2d36.2958931!3d33.5149141!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1518e76b678ca84b%3A0xc3e054baf19e9ec4!2sJsource%20company!5e0!3m2!1sar!2s!4v1622820930067!5m2!1sar!2s" frameBorder="0" allowFullScreen=""></iframe>

                    <div className="row mt-5">

                        <div className="col-lg-4">
                            <div className="info">
                                <div className="address">
                                    <i className="bi bi-geo-alt"></i>
                                    <h4>{t('Location')}:</h4>
                                    <p>{t('Damascus_Syria')}</p>
                                </div>

                                <div className="email">
                                    <i className="bi bi-envelope"></i>
                                    <h4>{t('Email')}:</h4>
                                    <p>jsource2022@gmail.com</p>
                                </div>

                                <div className="phone">
                                <a href="tel:0952336655"><i className="bi bi-phone"></i></a> 
                                    <h4>{t('Call')}:</h4>
                                    <p  dir="ltr" >0952336655</p>
                                </div>

                            </div>

                        </div>
                        <div className="col-lg-8 mt-5 mt-lg-0">
                        <ContactUs />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Contact
